// extracted by mini-css-extract-plugin
module.exports = {"button":"Homepage_button__TiJs7","requestDemoImage":"Homepage_requestDemoImage__YUJng","media":"Homepage_media__0dXdi","marquee":"Homepage_marquee__qKyQd"};